module.exports = __webpack_public_path__ + "img/cts.bca0b616.png";